import Vue from "vue";

Vue.mixin({
  methods: {
    nbspRem(v) {
      return v.replace(/&nbsp;/g, " ");
    },
    clearText(text) {
      if (this.$options.filters.striphtml(text) == "") {
        return  "";
      }
    },
  },
});
